import { render, staticRenderFns } from "./MULTIPLECHOICEA.vue?vue&type=template&id=7a808c6c&scoped=true&lang=pug"
import script from "./MULTIPLECHOICEA.vue?vue&type=script&lang=js"
export * from "./MULTIPLECHOICEA.vue?vue&type=script&lang=js"
import style0 from "./MULTIPLECHOICEA.vue?vue&type=style&index=0&id=7a808c6c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a808c6c",
  null
  
)

export default component.exports